import { Chat } from "@/types";

import { axios } from "../axios.instance";

export type UnarchiveChatRequest = {
  chatId: string;
};

export type UnarchiveChatResponse = Chat;

export const unarchiveChat = async (body: UnarchiveChatRequest): Promise<UnarchiveChatResponse> => {
  const { data } = await axios.post(`/chats/${body.chatId}/unarchive`);

  return data;
};
